"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildDescriptor;

var _protobufjs = _interopRequireDefault(require("protobufjs"));

var _descriptor = _interopRequireDefault(require("protobufjs/ext/descriptor"));

var _jsPascalcase = _interopRequireDefault(require("js-pascalcase"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * @typedef {Object} fieldData
 * @param {string} fieldData.name - field name
 * @param {string} fieldData.type - field type
 * @param {string} [fieldData.rule] - rule as according to proto3 standards (must be 'repeated' or `undefined`)
 * @param {array} [fieldData.values] - **only used for enum** enum values in an array
 * @param {number} [fieldData.index] - optionally declare proto tag number
 */

/**
 * helper function to build the descriptorSetProto filed in the recordTemplate.proto message
 * @param {fieldData|Array.<fieldData>} fieldData
 * @returns {Uint8Array | Buffer | never | void}
 */


function buildDescriptor(fieldData) {
  if (!Array.isArray(fieldData)) {
    fieldData = [fieldData];
  }

  var reg = /^[a-zA-Z]\w*$/;

  var _iterator = _createForOfIteratorHelper(fieldData),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;

      if (!reg.test(field.name)) {
        throw Error("invalid field name: ".concat(field.name, ". Must start with a letter and only contain letters/numbers."));
      }

      if (field.values) {
        var _iterator3 = _createForOfIteratorHelper(field.values),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var value = _step3.value;

            if (!reg.test(value)) {
              throw Error("invalid enum value: ".concat(value, " for enum field: ").concat(field.name, ". Must start with a letter and only contain letters/numbers."));
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var pRoot = new _protobufjs.default.Root();
  var tmplNameSpace = pRoot.define('oipProto.templates');
  tmplNameSpace.filename = 'p.proto';
  var Txid = new _protobufjs.default.Type('Txid').add(new _protobufjs.default.Field('raw', 1, 'bytes'));
  var P = new _protobufjs.default.Type('P');
  tmplNameSpace.add(P);
  var txidMessageAdded = false;
  var ENUM = 'enum';
  var OIP_REF = 'oipref';

  function serializeEnumValues(values, name) {
    name = (0, _jsPascalcase.default)(name);
    var enumValues = {};
    enumValues["".concat(name, "_UNDEFINED")] = 0; // set default value

    for (var index in values) {
      enumValues["".concat(name, "_").concat(values[index].toUpperCase())] = Number(index) + 1;
    }

    return enumValues;
  }

  var counter = 1;

  var _iterator2 = _createForOfIteratorHelper(fieldData),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _field = _step2.value;
      var index = counter;
      var name = (0, _lodash.camelCase)(_field.name);
      var rule = _field.rule;
      var enumValues = _field.values ? serializeEnumValues(_field.values, name) : undefined;
      var type = _field.type;

      var lowercaseType = _field.type.toLowerCase();

      var tag = _field.index || index;

      switch (lowercaseType) {
        case ENUM:
          {
            var pascalName = (0, _jsPascalcase.default)(name);
            P.add(new _protobufjs.default.Field(name, tag, ".oipProto.templates.P.".concat(pascalName), rule));
            P.add(new _protobufjs.default.Enum(pascalName, enumValues));
            break;
          }

        case OIP_REF:
          {
            if (!txidMessageAdded) {
              P.add(Txid);
              txidMessageAdded = true;
            }

            var _field2 = new _protobufjs.default.Field(name, tag, 'Txid', rule);

            P.add(_field2);
            break;
          }

        default:
          P.add(new _protobufjs.default.Field(name, tag, type, rule));
      }

      counter += 1;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var descriptorFromRoot = pRoot.toDescriptor('proto3');

  var buffer = _descriptor.default.FileDescriptorSet.encode(descriptorFromRoot).finish();

  return buffer;
}